export default __webpack_public_path__ + "static/media/boy-mask.6b98c1ee.png";